import { ModalComponent } from 'components/Modal';
import { FC } from 'react';
import { CandidateType } from '../Candidates/Candidates';
import { getActionNoun, getActionVerb, getSelectedCandidates, isUnevenSplit } from 'helpers/donate';
import { capitalizeString } from 'helpers/utils';
import { IPage } from 'store/donatePage/types';

interface Props {
  candidates: CandidateType[];
  children: React.ReactNode;
  isOpen: boolean;
  page?: IPage;
  setIsOpen: (isOpen: boolean) => void;
}

export const AmountDetailsModal: FC<Props> = ({
  candidates,
  children,
  isOpen,
  page,
  setIsOpen,
}) => {
  const closeModal = () => {
    setIsOpen(false);
  };
  const selectedCount = getSelectedCandidates(candidates).length;
  const actionNoun = getActionNoun(page);
  const isEvenAllocation = !page?.allocation_type || page.allocation_type === 'EVEN';
  const isSplitEqual = isEvenAllocation && !isUnevenSplit(candidates);

  return (
    <ModalComponent isOpen={isOpen} closeModal={closeModal} contentLabel="Amount details modal">
      <div className="mb10 modal-content">
        <div className="text-center">
          <div className="h3-dtm mb2">{capitalizeString(getActionVerb(page))}</div>
          <div className="body-text">Select the amount you wish to {getActionVerb(page)}.</div>
          {selectedCount > 1 && (
            <div className="body-text">
              {isSplitEqual
                ? `Your ${actionNoun} will be split equally among your selected ${selectedCount} recipients.`
                : `Your ${actionNoun} will be split among your ${selectedCount} selected recipients.`}
            </div>
          )}
        </div>
        {children}
      </div>
    </ModalComponent>
  );
};
